// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CGIQ","option":"styles_option__Z6SR7","selected":"styles_selected__2lkJU"};